import { FieldProps } from './types';
import { FieldWrapper } from './fieldWrapper';
import { AntInputNumber } from '../../../ant/antInputNumber';
import React from 'react';
import { observer } from 'mobx-react';

export const CERange = observer(({ property }: FieldProps) => {
	return (
		<FieldWrapper property={property}>
			<AntInputNumber max={property.max} min={property.min} step={property.increment} />
		</FieldWrapper>
	);
});
